import React from 'react'
import { useRef, useEffect, useState } from "react";
import '../assets/Nav.css';

class Nav extends React.Component {
  render() {
    return (
    <header>
       <nav className="navbar navbar-expand-md fixed-top navbar-dark">
          <div className="container-fluid">
             <a className="navbar-brand" href="#">JUSTIN<font>CODES</font></a>
            <a class="navbar-toggler collapsed border-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span> </span>
            <span> </span>
            <span> </span>
        </a>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav">
            <li className="nav-item"><a className="nav-link" href="#">Home</a></li>
            <li className="nav-item"><a className="nav-link" href="#About">About</a></li>
            <li className="nav-item"><a className="nav-link" href="#Project">Project</a></li>
            <li className="nav-item"><a className="nav-link" href="#Contact">Contact</a></li>
          </ul>
        </div>
    </div>
  </nav>
</header>
    )       
  }
}

export default Nav;